export default "__VITE_ASSET__B_zJN4SI__"